import { fabric } from "fabric";

export default (function() {
  function Circle(canvas, fillColor, strokeColor, strokeWidth) {
    this.canvas = canvas;
    this.className = "Circle";
    this.isDrawing = false;
    this.fillColor = fillColor || "#FFFFFF";
    this.strokeColor = strokeColor || "#000000";
    this.strokeWidth = strokeWidth || 2;
    this.canvas.selection = false;
    this.origX = null;
    this.bindEvents();
  }

  Circle.prototype.bindEvents = function() {
    this.canvas.on("mouse:down", (o) => {
      this.onMouseDown(o);
    });
    this.canvas.on("mouse:move", (o) => {
      this.onMouseMove(o);
    });
    this.canvas.on("mouse:up", (o) => {
      this.onMouseUp(o);
    });
    this.canvas.on("object:moving", () => {
      this.disable();
    });
  };

  Circle.prototype.onMouseUp = function() {
    this.canvas.renderAll();
    this.disable();
  };

  Circle.prototype.onMouseMove = function(o) {
    if (!this.isEnable()) {
      return;
    }

    var pointer = this.canvas.getPointer(o.e);
    var activeObj = this.canvas.getActiveObject();
    activeObj.set({
      radius: Math.abs(this.origX - pointer.x)
    });
    activeObj.setCoords();
    this.canvas.renderAll();
  };

  Circle.prototype.onMouseDown = function(o) {
    this.enable();
    var pointer = this.canvas.getPointer(o.e);

    this.origX = pointer.x;
    
    const circle = new fabric.Circle({
      left: pointer.x,
      top: pointer.y,
      radius: 1,
      strokeWidth: this.strokeWidth,
      stroke: this.strokeColor,
      fill: this.fillColor,
      selectable: true,
      originX: "center",
      originY: "center"
    });

    this.canvas.add(circle).setActiveObject(circle);
  };

  Circle.prototype.isEnable = function() {
    return this.isDrawing;
  };

  Circle.prototype.enable = function() {
    this.isDrawing = true;
  };

  Circle.prototype.disable = function() {
    this.isDrawing = false;
    this.canvas.discardActiveObject().renderAll();
  };

  return Circle;
})();